module.exports = "/packs/images/products/mango-bdc4171ecd90fe0a6879dd08a8aa7dfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/mango.jpg
// module id = 735
// module chunks = 0 1 2 4